<template>
    <div @click="selectCompanyCluster" class="flex w-full h-28  border-b border-gray-300 text-gray-800 hover:bg-indigo-50 cursor-pointer" @mouseenter="handleRowHover" @mouseleave="handleRowLeave">
        <div class="flex items-start h-full w-12" :style="rowSelectInputStyle">

        </div>
        <div class="font-normal cursor-pointer w-full h-full p-2" :style="rowContentStyle">
            <div class="pb-1">{{ clusterSize }} {{ resultLabel }} near:</div>
            <div class="tracking-wider font-medium whitespace-pre-wrap capitalize">
                {{ clusterLocation }}
            </div>
        </div>

    </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, computed } from 'vue';

const props = defineProps(['cluster'])

const emit = defineEmits(['select-company-cluster'])

const clusterSize = computed(() => {
    return props.cluster ? props.cluster.markers.length : 0
})

const resultLabel = computed(() => {
    return clusterSize.value == 1 ? 'Company' : 'Companies'
})

// const clusterPosition = computed(() => {
//     return props.cluster ? props.cluster.position() : null
// })
const clusterLocation = computed(() => {
    // console.log('clusterLocation', props.cluster.markers[0])
    let cityHash = {}
    let maxNumber = 0
    let maxCity = null
    for(let i=0; i < props.cluster.markers.length; i++) {
        if(props.cluster.markers[i].getAttribute('city-state-country')) {
            let cityKey = props.cluster.markers[i].getAttribute('city-state-country')
            if(cityKey in cityHash) {
                cityHash[cityKey] = cityHash[cityKey] + 1
            } else {
                cityHash[cityKey] = 1
            }
            if(cityHash[cityKey] > maxNumber) {
                maxCity = cityKey
                maxNumber = cityHash[cityKey]
            }
        }
    }
    // console.log(cityHash, maxCity, maxNumber)
    return maxCity
})

const rowHover = ref(false)

const rowSelectInputStyle = computed(() => {
    if(rowHover.value) {
        // return 'background-color: #e0e7ff;'
         return 'background-color: #c6d2ff;'
    } else {
        return 'background-color: #f3f4f6;'
        // return 'background-color #f9fafb;'
    } 
})

const rowContentStyle = computed(() =>{
    if(rowHover.value) {
        // return 'background-color: #eef2ff;'
        return 'background-color: #e0e7ff;'
    } else {
        return 'background-color: white;'
    }
})

function handleRowHover() {
    rowHover.value = true
}

function handleRowLeave() {
    rowHover.value = false
}

function selectCompanyCluster() {
    emit('select-company-cluster', props.cluster)
}

</script>